export enum DataValueSortType {
  SourceTitle = "SourceTitle",
  HazardCategory = "HazardCategory",
  EvaluationRating = "EvaluationRating",
  HazardAgent = "HazardAgent",
  SiValue = "SiValue",
  Property = "Property",
}
